import Image from "next/image";
import React from "react";
import styles from "./opsc-mains.module.css";
import Carousel from 'react-bootstrap/Carousel';
import Image1 from "next/legacy/image";
import handIcon from "../../assets/images/header/touch-01.png";
import crashcourse from "../../assets/images/home/Moksha/Opsc-Mains-2026-Web-Banner.jpg";
import Mobcrashcourse from "../../assets/images/home/Moksha/Opsc-Mains-2026-Mob-Banner.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import Link from "next/link";
import Head from "next/head";

const UPSC_Main_Test_Series_2023 = () => {
    const BGimg = [
        //{ img: carouselBGimg4, alt: "carousel", link: "/" },
        //{ img: carouselBGimg3, alt: "carousel", link: "/upsc-mains-test-series" }
    ]

     const feestructure3 =[

        {gs: (<a
                    href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-FRESHERS-2026.pdf"
                    target="_blank"
                    className={styles.pdfBtn}
                    >
                </a>),
   optional: (<a
                    href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-FRESHERS-2026.pdf"
                    target="_blank"
                    className={styles.pdfBtn}
                    >
                </a>)
            },

        
        ]
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Moksha OPSC Mains Test Series 2026 | GS & Optional | Odisha Civil Services</title>
            <meta name="title" content="Moksha OPSC Mains Test Series 2026 | GS & Optional | Odisha Civil Services" />
            <meta name="description" content="Join Moksha OPSC Mains Test Series for Odisha Civil Services Examination. Comprehensive General Studies (GS) and Optional Subject test series with expert evaluation, answer writing practice, model answers, and performance analysis." />
            <meta name="keywords" content="Moksha OPSC Mains Test Series,OPSC Civil Services Mains Test Series,OPSC GS Test Series,OPSC Optional Test Series,Odisha Civil Services Test Series,OPSC Answer Writing Programme,OPSC Mains Mock Test,OPSC GS & Optional Test Series,Best OPSC Mains Test ,OPSC Mains Coaching"/>
            <link rel="canonical" href=" https://www.shankariasacademy.com/opsc-mains-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Moksha OPSC Mains Test Series 2026 | GS & Optional | Odisha Civil Services" />
            <meta property="og:description" content="Join Moksha OPSC Mains Test Series for Odisha Civil Services Examination. Comprehensive General Studies (GS) and Optional Subject test series with expert evaluation, answer writing practice, model answers, and performance analysis." />
            <meta property="og:url" content=" https://www.shankariasacademy.com/opsc-mains-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

        <Navbar title="upsc" />

        <div className="container">
           <div className="col-md-6 pt-3 pb-3">
                <h1 className={`${styles.pagemaintitle}`}>OPSC Mains GS & Optional Test Series 2026</h1>
            </div>
        </div>

        <div className="container">

            <div className="row d-none d-md-block">
                <div className="col mb-3">
                <Image
                    src={crashcourse}
                    alt="UPSC Mains Crash Course 2024"
                    title="UPSC Mains Crash Course 2024"
                    className="img-fluid w-100"
                />
                </div>
            </div>

            <div className="row d-block d-md-none">
            <div className="col mb-3">
                <Image
                    src={Mobcrashcourse}
                    alt="UPSC Mains Crash Course 2024"
                    title="UPSC Mains Crash Course 2024"
                    className="img-fluid w-100"
                />
                </div>
            </div> 
        </div>

       <div className="container py-5">
            <div className={`${styles.paymentCard} row g-0 align-items-center`}>

                {/* Left */}
                <div className="col-lg-5">
                <div className={styles.leftBox}>
                    <h2>Moksha Mains Test Series</h2>

                    <p>
                    Odisha Public Service Commission (OPSC)
                    <br />
                    Civil Services Examination
                    </p>

                   
                </div>
                </div>

                {/* Center */}
                <div className="col-lg-5">
                     <p className="d-flex justify-content-center mb-3">
                      <strong>Starts On : </strong> 09 August 2026
                    </p>
                <div className={styles.feeCard}>

                    <div className="d-flex justify-content-between mb-3">
                    <span>GS Test Series</span>
                    <strong>₹7,500</strong>
                    </div>

                    <div className="d-flex justify-content-between mb-3">
                    <span>Optional Test Series</span>
                    <strong>₹2,500</strong>
                    </div>

                    <hr />

                    <div className="d-flex justify-content-between">
                    <strong>Total Fee</strong>
                    <h4 className=" mb-0" style={{color:"#dd0017",fontSize:"20px",fontWeight:"600"}}>₹10,000</h4>
                    </div>

                </div>
                </div>

                {/* Right */}
                <div className="col-lg-2">

                <div className={styles.scheduleCard}>

                    <a
                        href="https://admissionsv1.shankariasacademy.com/?center=BHUBANESWAR&coursetype=MOKSHA"
                        target="_blank"
                        className={styles.admissionBtn}
                    >
                        Pay Now
                    </a>

                </div>

                </div>

            </div>
        </div>

    <section id="courseandfees" className="py-5">
        <div className="container">

            <div className="table-responsive">
                <table className={`table table-bordered ${styles.scheduleTable}`}>
                    <thead>
                        <tr>
                            <th width="10%">S.No</th>
                            <th width="50%">Programme</th>
                            <th width="20%">Type</th>
                            <th width="20%">Schedule</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td className="text-center">1</td>
                            <td>Moksha OPSC Mains Test Series - General Studies</td>
                            <td className="text-center">GS</td>
                            <td className="text-center">
                                <a
                                    href="https://www.shankariasacademy.com/pdf/UPSC-2026/OPSC-Mains/MOKSHA-OPSC-MAINS-GS-TEST-SERIES-SYLLABUS-2026.pdf"
                                    target="_blank"
                                    className={styles.pdfBtn}
                                >
                                    Download PDF
                                </a>
                            </td>
                        </tr>

                        <tr>
                            <td className="text-center">2</td>
                            <td>Moksha OPSC Mains Test Series - Optional Subject</td>
                            <td className="text-center">Sociology</td>
                            <td className="text-center">
                                <a
                                    href="https://www.shankariasacademy.com/pdf/UPSC-2026/OPSC-Mains/OPSC-SOCIOLOGY-OPTIONAL-TEST-SERIES.pdf"
                                    target="_blank"
                                    className={styles.pdfBtn}
                                >
                                    Download PDF
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </section>

        <Footer />
    </>
    )
}
export default UPSC_Main_Test_Series_2023;
